module.exports = __webpack_public_path__ + "img/laravelui-logo.3f905953.png";